import { colors } from "../../../../data/colors";
import { emptys } from "../../../../data/main";
import { stdObject } from "../../../../data/types/stdObject";
import { toPrice } from "../../../../utils/toPrice";

const writePref = (key: string) => (key === "PRE" ? "PREP" : key);

export const writeAccountingReport = ({
  t,
  id,
  searchValues,
  responseReportData,
  vPayments,
  cPayments,
}: stdObject) => {
  let balance = responseReportData.previous;
  return {
    ...searchValues,
    [id]: {
      ...searchValues[id],
      results: [
        { NAME: t("p.previousBalance"), BALCAJ: toPrice(balance) },
        ...responseReportData.list
          .sort((a: stdObject, b: stdObject) =>
            a.FECCAJ.localeCompare(b.FECCAJ),
          )
          .flatMap((e: stdObject) => {
            balance = e.RESCAJ ? e.ENTCAJ : balance + e.ENTCAJ - e.SALCAJ;
            const payList =
              e.MKEY === "CAJ"
                ? e.ENTCAJ !== 0
                  ? vPayments
                  : e.SALCAJ !== 0
                    ? cPayments
                    : vPayments
                : e.AREA === "c"
                  ? cPayments
                  : vPayments;
            const method = e.RESCAJ
              ? ""
              : e.TRACAJ !== null
                ? t("p.transaction")
                : payList.find((v: stdObject) => v.CODTPA === e.TIPDIN)?.NOMTPA;
            const base = {
              ...e,
              TIPDIN: method,
              NAME:
                e.MKEY === "DIN"
                  ? t(`c.${writePref(e.NOMCAJ)}`) + ` ${e.SERDIN}-${e.CODDIN}`
                  : e.NOMCAJ +
                    (e.RESCAJ ? ` (${t("p.balanceCorrection")})` : "") +
                    (!emptys.includes(e.OBSDIN) ? ` (${e.OBSDIN})` : ""),
              ENTCAJ: e.ENTCAJ === 0 ? "-" : toPrice(e.ENTCAJ),
              SALCAJ: e.SALCAJ === 0 ? "-" : toPrice(e.SALCAJ),
              BALCAJ: toPrice(balance),
              BGCOLOR: e.RESCAJ ? colors.lightYellow : null,
            };

            if (e.CARDIN === 0) {
              return [base];
            } else {
              balance -= e.CA2DIN;
              return [
                base,
                {
                  ...e,
                  TIPDIN: method,
                  NAME:
                    t(`c.${writePref(e.NOMCAJ)}`) +
                    ` ${e.SERDIN}-${e.CODDIN} (${t("p.collectionFee")})`,
                  ENTCAJ: "-",
                  SALCAJ: toPrice(e.CA2DIN),
                  BALCAJ: toPrice(balance),
                  BGCOLOR: colors.lightViolet,
                },
              ];
            }
          }),
      ],
    },
  };
};
